import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { Inbox } from 'lucide-react';
import { useUnreadCount } from '../../notifications/notifications';

/** "Inbox" in every sidebar, with the unread count. A file of its own: the inbox page and its
 *  styles stay in their lazy chunk. */
export function InboxNavItem({ active }: { active: boolean }) {
  const { t } = useTranslation();
  const unread = useUnreadCount().data ?? 0;
  return (
    <Link to="/inbox" className="nav-item" data-active={active}>
      <Inbox size={17} />
      <span className="nav-label">{t('inbox.title')}</span>
      {unread > 0 && <span className="count inbox-count">{unread > 99 ? '99+' : unread}</span>}
    </Link>
  );
}
